import * as React from "react";
const SvgUnsplash = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8.25 7.625V2h7.5v5.625h-7.5Zm7.5 3.125H22V22H2V10.75h6.25v5.625h7.5V10.75Z", fill: "currentColor" }));
export default SvgUnsplash;
